import type { Renderer } from "@googlemaps/markerclusterer";
import { SuperClusterAlgorithm } from "@googlemaps/markerclusterer";
import { typography } from "@ecco/ui/tokens";
import { createMarker } from "./map-markers";
import { icon } from "./icons";

export const clusterRenderer: Renderer = {
    render: ({ count, position }) =>
        createMarker({
            position,
            icon: {
                url: icon.cluster.src,
                scaledSize: new google.maps.Size(42, 42),
            },
            zIndex: 2,
            visible: count > 0,
            label: {
                text: String(count),
                color: "#ffffff",
                fontSize: "16px",
                fontFamily: typography.fonts.heading,
                fontWeight: "bold",
            },
        }),
};

export const clusterAlgorithm = new SuperClusterAlgorithm({
    radius: 120,
    maxZoom: 11,
});
